import GeneralSK from './general/sk';
import GeneralEN from './general/en';
import DashboardSK from './dashboard/sk';
import DashboardEN from './dashboard/en';
import NavigationSK from './navigation/sk';
import NavigationEN from './navigation/en';
import CompanyDataSK from './company-data/sk';
import CompanyDataEN from './company-data/en';
import VenuesSK from './venues/sk';
import VenuesEN from './venues/en';
import OpeningHoursSK from './opening-hours/sk';
import OpeningHoursEN from './opening-hours/en';
import PlaylistSK from './playlist/sk';
import PlaylistEN from './playlist/en';
import AppFeaturesSK from './app-features/sk';
import AppFeaturesEN from './app-features/en';
import SubscriptionAndBillingSK from './subscription-billing/sk';
import SubscriptionAndBillingEN from './subscription-billing/en';
import PaymentMethodsSK from './payment-methods/sk';
import PaymentMethodsEN from './payment-methods/en';
import UserManagementSK from './user-managment/sk';
import UserManagementEN from './user-managment/en';
import CommunicationWithCustomersSK from './communication-with-customers/sk';
import CommunicationWithCustomersEN from './communication-with-customers/en';
import HelpAndSupportSK from './help-and-support/sk';
import HelpAndSupportEN from './help-and-support/en';
import SubscriptionPlanSK from './subscription-plan/sk';
import SubscriptionPlanEN from './subscription-plan/en';
import ValidationsSK from './validations/sk';
import ValidationsEN from './validations/en';
import TooltipsSK from './tooltips/sk';
import TooltipsEN from './tooltips/en';
import RegistrationSK from './registration/sk';
import RegistrationEN from './registration/en';
import FooterSK from './footer/sk';
import FooterEN from './footer/en';
import SuccessErrorMessageSK from './success-error-message/sk';
import SuccessErrorMessageEN from './success-error-message/en';
import AdminzoneTranslationsSK from './adminzone/sk';
import AdminzoneTranslationsEN from './adminzone/en';


export default {
  "sk": {
    ...(GeneralSK),
    ...(DashboardSK),
    ...(NavigationSK),
    ...(CompanyDataSK),
    ...(VenuesSK),
    ...(OpeningHoursSK),
    ...(PlaylistSK),
    ...(AppFeaturesSK),
    ...(SubscriptionAndBillingSK),
    ...(PaymentMethodsSK),
    ...(UserManagementSK),
    ...(CommunicationWithCustomersSK),
    ...(HelpAndSupportSK),
    ...(SubscriptionPlanSK),
    ...(ValidationsSK),
    ...(TooltipsSK),
    ...(RegistrationSK),
    ...(FooterSK),
    ...(SuccessErrorMessageSK),
    ...(AdminzoneTranslationsSK),

  },
  "en": {
    ...(GeneralEN),
    ...(DashboardEN),
    ...(NavigationEN),
    ...(CompanyDataEN),
    ...(VenuesEN),
    ...(OpeningHoursEN),
    ...(PlaylistEN),
    ...(AppFeaturesEN),
    ...(SubscriptionAndBillingEN),
    ...(PaymentMethodsEN),
    ...(UserManagementEN),
    ...(CommunicationWithCustomersEN),
    ...(HelpAndSupportEN),
    ...(SubscriptionPlanEN),
    ...(ValidationsEN),
    ...(TooltipsEN),
    ...(RegistrationEN),
    ...(FooterEN),
    ...(SuccessErrorMessageEN),
    ...(AdminzoneTranslationsEN),
  }
}
